

























import { Component, Vue } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AddressStore, { AddressShowDto } from '@/stores/user/address.store';
import AddressShow from '@/views/account/user/AddressShow.vue';
import AddressEditForm from '@/views/account/user/AddressEditForm.vue';
import { Addresses } from '@/util/Addresses';
import LoadingIndicator from '@/views/common/LoadingIndicator.vue';
import Routes from '@/util/Routes';

@Component({
  components: {LoadingIndicator, AddressEditForm, AddressShow},
})
export default class AddressList extends Vue {
  private loading = true;
  private addressStore = getModule(AddressStore, this.$store);

  private get addressList(): AddressShowDto[] {
    return this.addressStore.addressShowList;
  }

  public async mounted() {
    await this.refreshAddresses();
    this.loading = false;
  }

  get duringCheckout() {
    return this.$route.matched.some((record) => record.meta.checkoutHeader);
  }

  private async refreshAddresses() {
    try {
      this.loading = true;
      await this.addressStore.fetchAddresses();
    } finally {
      this.loading = false;
    }
  }

  private addLocalAddress() {
    this.addressList.push({address: Addresses.emptyAddress(), edit: true});
  }

  private async deleteAddress(address: AddressShowDto) {
    if (address.address.id) {
      this.loading = true;
      try {
        await this.addressStore.deleteUserAddress(address.address.id);
        await this.refreshAddresses();
      } finally {
        this.loading = false;
      }
    } else {
      const index = this.addressList.indexOf(address);
      if (index > -1) {
        this.addressList.splice(index, 1);
      }
    }
  }

  private async abortEdit(address: AddressShowDto) {
    address.edit = false;
    await this.refreshAddresses();
  }

  private navigateToCheckout() {
    this.$router.push({name: Routes.OrderAddressStep});
  }
}
